export default __webpack_public_path__ + "static/media/paypal_recurring_diet.890a1f13.svg";